import { useContext } from "react";
import { RecaptchaContext } from "../../context/context/RecaptchaContext.js";
function useRecaptcha() {
  const context = useContext(RecaptchaContext);
  if (!context) {
    throw new Error(
      "useRecaptcha must be used within a RecaptchaProvider. Make sure to wrap your component tree with <RecaptchaProvider>."
    );
  }
  return context;
}
function useRecaptchaSafe() {
  const context = useContext(RecaptchaContext);
  return context;
}
export {
  useRecaptcha,
  useRecaptchaSafe
};
//# sourceMappingURL=useRecaptcha.js.map
